import * as TYPES from './actions/types';
import * as mutator from './appointment-mutators';

export const initialState = {
  appointments: [],
  upcomingAppointments: [],
  unfilteredCount: 0,
  showFilterPanel: false,
  patientNotifyPreference: 'Off',
  sortOption: {
    field: 'date',
    direction: 'ASC',
  },
  filter: {
    status: '',
    appointmentType: '',
    provider: '',
    date: 'All',
  },
  filterOptions: {
    statuses: [],
    appointmentTypes: [],
    providers: [],
  },
};

export const getDefaultFilter = () => (
  {
    status: initialState.filter.status,
    provider: initialState.filter.provider,
    appointmentType: initialState.filter.appointmentType,
    date: initialState.filter.date,
  }
);

export const appointmentsReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.APPOINTMENTS_LOADED:
      newState = {

        ...state,
        ...mutator.setAppointments(action.appointments)(state),
        ...mutator.mapAppointments(action.appointments)(state) };
      newState = {

        ...newState,
        ...mutator.setAppointmentsFilter(newState.filter)(newState) };
      newState = {

        ...newState,
        ...mutator.sortPatientAppointments(newState.sortOption)(newState) };
      break;
    case TYPES.APPOINTMENTS_SORTED:
      newState = {

        ...state,
        sortOption: action.sortOption,
      };
      break;
    case TYPES.APPOINTMENTS_FILTERED:
      newState = {

        ...state,
        ...mutator.setAppointmentsFilter(action.filter)(state) };
      newState = {

        ...newState,
        ...mutator.sortPatientAppointments(newState.sortOption)(newState) };
      break;
    case TYPES.APPOINTMENTS_USER_PREFERENCE_LOADED:
      newState = {

        ...state,
        ...mutator.setDateFilterPreference(action.filter)(state) };
      break;
    case TYPES.APPOINTMENTS_PATIENT_NOTIFY_PREFERENCE_LOADED:
      newState = { ...state, patientNotifyPreference: action.patientNotifyPreference };
      break;
    case TYPES.UPCOMING_APPOINTMENTS_LOADED:
      newState = {

        ...state,
        ...mutator.setAppointments(action.upcomingAppointments)(state),
        ...mutator.mapAppointments(action.upcomingAppointments, true)(state) };
      break;
    case TYPES.UPCOMING_APPOINTMENTS_LOAD_FAILED:
      newState = {

        ...state,
        upcomingAppointments: action.upcomingAppointments };
      break;
    case TYPES.APPOINTMENTS_TOGGLE_FILTER_PANEL:
      newState = { ...state,
        ...mutator.toggleFilters(action.showFilterPanel)(state) };
      break;
    default:
      newState = state;
  }
  return newState;
};

export default appointmentsReducer;